import { useState } from "react";
import { Get, Set } from "../../../../../Request";

export const useReportCreate = (isApp, reloadPage, setReloadPage) => {
  const [loading, setLoading] = useState(false);
  const store = async data => {
    setLoading(true);
    Set({
      url: "/report_bug/create",
      data: { ...data },
    }).then(response => {
      setLoading(false);
      if (isApp) {
        setReloadPage(reloadPage + 1)
      }
    });
  };
  return {
    store,
    loading,
  };
};
export const useReportList = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modal, setModal] = useState({ visible: false });
  const getData = async data => {
    setLoading(true);
    Get({
      url: "/report_bug/user_list",
      data: { ...data },
    }).then(response => {
      setList(response);
      setLoading(false);
    });
  };
  return {
    getData,
    loading,
    list,
    modal,
    setModal,
  };
};
export const useReportSingle = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const getData = async data => {
    setLoading(true);
    Get({
      url: "/report_bug/user_single",
      data: { ...data },
    }).then(response => {
      setData(response);
      setLoading(false);
    });
  };
  return {
    getData,
    loading,
    data,
  };
};
